import { Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Routes } from 'routes';
import { colors } from 'theme';

interface ErrorLinkProps {
  prelinkText?: string;
  linkText: string;
  onClick?: () => void;
  to?: string;
}

export const ErrorLink: React.FC<ErrorLinkProps> = ({ prelinkText, linkText, onClick, to }) => {
  const { t } = useTranslation();
  return (
    <span>
      <b>{t('closureCloseForm.step1.noticeAnError')}</b>
      {prelinkText}&nbsp;
      {to && (
        <RouterLink to={Routes.Clients} style={{ color: colors.grey900 }}>
          {linkText}
        </RouterLink>
      )}
      {onClick && (
        <Link
          style={{ textTransform: 'inherit', verticalAlign: 'initial', fontSize: 14 }}
          underline="always"
          component="button"
          variant="body2"
          onClick={onClick}
        >
          {linkText}
        </Link>
      )}
    </span>
  );
};
